import { SectionWrapper, SectionHeader, SectionContent } from '../section'

import type { PropsWithChildren } from '../../../types'

type Props = PropsWithChildren<{ title: string }>

function OutreachSection({ children, title }: Props) {
  return (
    <SectionWrapper>
      <SectionHeader title={title} />
      <SectionContent>{children}</SectionContent>
    </SectionWrapper>
  )
}

export { OutreachSection }
